/** RFC 4180 CSV: fields with a comma, quote or line break are quoted; quotes are doubled. */
export function toCsv(header: string[], rows: (string | number | null)[][]): string {
    const cell = (v: string | number | null) => {
        const s = v === null ? '' : String(v);
        return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };
    return [header, ...rows].map(r => r.map(cell).join(',')).join('\r\n');
}

/** A safe file name from free text: letters, digits, dash and underscore. */
export function fileNameOf(text: string): string {
    return text.trim().replace(/[^\p{L}\p{N}_-]+/gu, '-').replace(/^-+|-+$/g, '').slice(0, 80) || 'export';
}

/** Save rows as a CSV file in the browser (UTF-8 with a byte order mark, so Excel reads accents correctly). */
export function downloadCsv(name: string, header: string[], rows: (string | number | null)[][]): void {
    const blob = new Blob([`\uFEFF${toCsv(header, rows)}`], {type: 'text/csv;charset=utf-8'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileNameOf(name)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
}
